<app-sidenav>

  <div class="px-4" style="padding-top: 25px; padding-bottom: 25px;">
    <router-outlet></router-outlet>
  </div>

</app-sidenav>
